/**
 * is Development?
 */

const IsDev = function() {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
}

export default IsDev;